import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { FENERUM_ACCOUNT_BASE_URL } from "@/v2-backoffice-client/constants"
import type { LicenseAccountFragment } from "@/v2-backoffice-client/license/account/__types__/license.account.fragment"

export type LicenseAccountTableRowToolbarProps = {
  account: LicenseAccountFragment
}

function LicenseAccountTableRowToolbar(
  props: LicenseAccountTableRowToolbarProps,
) {
  const { account } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />
      <ActionMenu.Content>
        <ActionMenu.LinkItem
          iconSrc="expand"
          to={`?v=billingAccount:${account.Id}`}
        >
          Open Panel
        </ActionMenu.LinkItem>

        <ActionMenu.LinkItem
          iconSrc="bank"
          to={`${FENERUM_ACCOUNT_BASE_URL}/${account.ExternalAccountUuid}/`}
          external
        >
          Open in Fenerum
        </ActionMenu.LinkItem>

        {account.ExternalCustomerId && (
          <ActionMenu.LinkItem
            iconSrc="expand"
            to={`?v=customer:${account.ExternalCustomerId}`}
          >
            Open Customer Panel
          </ActionMenu.LinkItem>
        )}
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LicenseAccountTableRowToolbar
